/** CoStar.Api.Listings.ViewModels.Search.AuctionListingType */
export var AuctionListingType;
(function (AuctionListingType) {
    AuctionListingType[AuctionListingType["None"] = 0] = "None";
    AuctionListingType[AuctionListingType["PropertyForAuction"] = 1] = "PropertyForAuction";
    AuctionListingType[AuctionListingType["LandForAuction"] = 2] = "LandForAuction";
    AuctionListingType[AuctionListingType["CondoForAuction"] = 4] = "CondoForAuction";
    AuctionListingType[AuctionListingType["PropertyLoanForAuction"] = 8] = "PropertyLoanForAuction";
    AuctionListingType[AuctionListingType["CommercialPortfolioForAuction"] = 16] = "CommercialPortfolioForAuction";
})(AuctionListingType || (AuctionListingType = {}));
/** CoStar.Api.Listings.ViewModels.Search.ContactRoles */
export var ContactRoles;
(function (ContactRoles) {
    ContactRoles[ContactRoles["None"] = 0] = "None";
    ContactRoles[ContactRoles["Broker"] = 1] = "Broker";
    ContactRoles[ContactRoles["Owner"] = 2] = "Owner";
})(ContactRoles || (ContactRoles = {}));
/** CoStar.Api.Listings.ViewModels.Search.FilterAction */
export var FilterAction;
(function (FilterAction) {
    FilterAction[FilterAction["Intersect"] = 0] = "Intersect";
    FilterAction[FilterAction["Except"] = 1] = "Except";
    FilterAction[FilterAction["Union"] = 2] = "Union";
})(FilterAction || (FilterAction = {}));
/** CoStar.Api.Listings.ViewModels.Search.SpaceTypes */
export var SpaceTypes;
(function (SpaceTypes) {
    SpaceTypes[SpaceTypes["None"] = 0] = "None";
    SpaceTypes[SpaceTypes["Relet"] = 1] = "Relet";
    SpaceTypes[SpaceTypes["New"] = 2] = "New";
    SpaceTypes[SpaceTypes["Sublet"] = 4] = "Sublet";
    SpaceTypes[SpaceTypes["Assignment"] = 8] = "Assignment";
})(SpaceTypes || (SpaceTypes = {}));
/** CoStar.Api.Listings.ViewModels.Search.UseClasses */
export var UseClasses;
(function (UseClasses) {
    UseClasses[UseClasses["None"] = 0] = "None";
    UseClasses[UseClasses["A1"] = 1] = "A1";
    UseClasses[UseClasses["A2"] = 2] = "A2";
    UseClasses[UseClasses["A3"] = 4] = "A3";
    UseClasses[UseClasses["A4"] = 8] = "A4";
    UseClasses[UseClasses["A5"] = 16] = "A5";
    UseClasses[UseClasses["NotSpecified"] = 32] = "NotSpecified";
    UseClasses[UseClasses["Class1"] = 64] = "Class1";
    UseClasses[UseClasses["Class2"] = 128] = "Class2";
    UseClasses[UseClasses["Class3"] = 256] = "Class3";
    UseClasses[UseClasses["SuiGeneris"] = 512] = "SuiGeneris";
    UseClasses[UseClasses["Class4"] = 1024] = "Class4";
    UseClasses[UseClasses["Class5"] = 2048] = "Class5";
    UseClasses[UseClasses["Class6"] = 4096] = "Class6";
    UseClasses[UseClasses["Class7"] = 8192] = "Class7";
    UseClasses[UseClasses["Class8"] = 16384] = "Class8";
    UseClasses[UseClasses["Class9"] = 32768] = "Class9";
    UseClasses[UseClasses["Class10"] = 65536] = "Class10";
    UseClasses[UseClasses["Class11"] = 131072] = "Class11";
    UseClasses[UseClasses["B1"] = 262144] = "B1";
    UseClasses[UseClasses["B2"] = 524288] = "B2";
    UseClasses[UseClasses["B8"] = 1048576] = "B8";
    UseClasses[UseClasses["C1"] = 2097152] = "C1";
    UseClasses[UseClasses["C2"] = 4194304] = "C2";
    UseClasses[UseClasses["C2A"] = 8388608] = "C2A";
    UseClasses[UseClasses["C3"] = 16777216] = "C3";
    UseClasses[UseClasses["D1"] = 33554432] = "D1";
    UseClasses[UseClasses["D2"] = 67108864] = "D2";
    UseClasses[UseClasses["E"] = 134217728] = "E";
    UseClasses[UseClasses["F1"] = 268435456] = "F1";
    UseClasses[UseClasses["F2"] = 536870912] = "F2";
})(UseClasses || (UseClasses = {}));
/** CoStar.Api.Listings.ViewModels.Search.BuildOuts */
export var BuildOuts;
(function (BuildOuts) {
    BuildOuts[BuildOuts["None"] = 0] = "None";
    BuildOuts[BuildOuts["RestaurantsAndCafes"] = 1] = "RestaurantsAndCafes";
    BuildOuts[BuildOuts["FastFood"] = 2] = "FastFood";
    BuildOuts[BuildOuts["DrinkingEstablishment"] = 4] = "DrinkingEstablishment";
})(BuildOuts || (BuildOuts = {}));
/** CoStar.Api.Listings.ViewModels.Search.SpaceLayoutTypes */
export var SpaceLayoutTypes;
(function (SpaceLayoutTypes) {
    SpaceLayoutTypes[SpaceLayoutTypes["None"] = 0] = "None";
    SpaceLayoutTypes[SpaceLayoutTypes["OpenPlan"] = 1] = "OpenPlan";
    SpaceLayoutTypes[SpaceLayoutTypes["MostlyOpenPlan"] = 2] = "MostlyOpenPlan";
    SpaceLayoutTypes[SpaceLayoutTypes["PrivateOffices"] = 4] = "PrivateOffices";
})(SpaceLayoutTypes || (SpaceLayoutTypes = {}));
/** CoStar.Api.Listings.ViewModels.Search.SaleStatuses */
export var SaleStatuses;
(function (SaleStatuses) {
    SaleStatuses[SaleStatuses["None"] = 0] = "None";
    SaleStatuses[SaleStatuses["Active"] = 1] = "Active";
    SaleStatuses[SaleStatuses["Escrow"] = 2] = "Escrow";
    SaleStatuses[SaleStatuses["Pending"] = 4] = "Pending";
    SaleStatuses[SaleStatuses["UnderContract"] = 8] = "UnderContract";
})(SaleStatuses || (SaleStatuses = {}));
/** CoStar.Api.Listings.ViewModels.Search.SaleConditions */
export var SaleConditions;
(function (SaleConditions) {
    SaleConditions[SaleConditions["None"] = 0] = "None";
    SaleConditions[SaleConditions["DistressSale"] = 1] = "DistressSale";
    SaleConditions[SaleConditions["TenThirtyOneExchange"] = 2] = "TenThirtyOneExchange";
    SaleConditions[SaleConditions["SaleLeaseback"] = 4] = "SaleLeaseback";
    SaleConditions[SaleConditions["GroundLeaseLeasehold"] = 8] = "GroundLeaseLeasehold";
    SaleConditions[SaleConditions["GroundLeaseLeasedFee"] = 16] = "GroundLeaseLeasedFee";
    SaleConditions[SaleConditions["InvestmentTripleNet"] = 32] = "InvestmentTripleNet";
    SaleConditions[SaleConditions["DirectExchange"] = 64] = "DirectExchange";
    SaleConditions[SaleConditions["Assemblage"] = 128] = "Assemblage";
    SaleConditions[SaleConditions["AuctionSale"] = 256] = "AuctionSale";
    SaleConditions[SaleConditions["BuildToSuit"] = 512] = "BuildToSuit";
    SaleConditions[SaleConditions["BulkPortfolioSale"] = 1024] = "BulkPortfolioSale";
    SaleConditions[SaleConditions["BusinessValueIncluded"] = 2048] = "BusinessValueIncluded";
    SaleConditions[SaleConditions["CondoConversion"] = 4096] = "CondoConversion";
    SaleConditions[SaleConditions["DeedRestriction"] = 8192] = "DeedRestriction";
    SaleConditions[SaleConditions["EstateProbateSale"] = 16384] = "EstateProbateSale";
    SaleConditions[SaleConditions["HistoricalSite"] = 32768] = "HistoricalSite";
    SaleConditions[SaleConditions["LeaseOption"] = 65536] = "LeaseOption";
    SaleConditions[SaleConditions["BuildingContaminationIssue"] = 131072] = "BuildingContaminationIssue";
    SaleConditions[SaleConditions["DeferredMaintenance"] = 262144] = "DeferredMaintenance";
    SaleConditions[SaleConditions["DoubleEscrow"] = 524288] = "DoubleEscrow";
    SaleConditions[SaleConditions["ExerciseOfOption"] = 1048576] = "ExerciseOfOption";
    SaleConditions[SaleConditions["ExcessLand"] = 2097152] = "ExcessLand";
    SaleConditions[SaleConditions["Expansion"] = 4194304] = "Expansion";
    SaleConditions[SaleConditions["HighVacancyProperty"] = 8388608] = "HighVacancyProperty";
    SaleConditions[SaleConditions["LandContract"] = 16777216] = "LandContract";
    SaleConditions[SaleConditions["PartialInterestTransfer"] = 33554432] = "PartialInterestTransfer";
    SaleConditions[SaleConditions["PurchaseByTenant"] = 67108864] = "PurchaseByTenant";
    SaleConditions[SaleConditions["RedevelopmentProject"] = 134217728] = "RedevelopmentProject";
    SaleConditions[SaleConditions["RollingOptionTakedown"] = 268435456] = "RollingOptionTakedown";
    SaleConditions[SaleConditions["SoilContaminationIssue"] = 536870912] = "SoilContaminationIssue";
    SaleConditions[SaleConditions["BuildingInShellCondition"] = 1073741824] = "BuildingInShellCondition";
    SaleConditions[SaleConditions["RealEstateOwned"] = 2147483648] = "RealEstateOwned";
    SaleConditions[SaleConditions["ShortSale"] = 4294967296] = "ShortSale";
    SaleConditions[SaleConditions["ThreatOfCondemnation"] = 8589934592] = "ThreatOfCondemnation";
    SaleConditions[SaleConditions["CourtAppointedSale"] = 17179869184] = "CourtAppointedSale";
    SaleConditions[SaleConditions["Recapitalization"] = 34359738368] = "Recapitalization";
    SaleConditions[SaleConditions["DebtAssumption"] = 68719476736] = "DebtAssumption";
    SaleConditions[SaleConditions["NotePurchase"] = 137438953472] = "NotePurchase";
    SaleConditions[SaleConditions["BankruptcySale"] = 274877906944] = "BankruptcySale";
    SaleConditions[SaleConditions["ZeroCashFlowInvestment"] = 549755813888] = "ZeroCashFlowInvestment";
})(SaleConditions || (SaleConditions = {}));
/** CoStar.Api.Listings.ViewModels.Search.SaleTypes */
export var SaleTypes;
(function (SaleTypes) {
    SaleTypes[SaleTypes["None"] = 0] = "None";
    SaleTypes[SaleTypes["Investment"] = 1] = "Investment";
    SaleTypes[SaleTypes["OwnerUser"] = 2] = "OwnerUser";
})(SaleTypes || (SaleTypes = {}));
/** CoStar.Api.Listings.ViewModels.Search.TenancyTypes */
export var TenancyTypes;
(function (TenancyTypes) {
    TenancyTypes[TenancyTypes["None"] = 0] = "None";
    TenancyTypes[TenancyTypes["Single"] = 1] = "Single";
    TenancyTypes[TenancyTypes["Multiple"] = 2] = "Multiple";
})(TenancyTypes || (TenancyTypes = {}));
/** CoStar.Api.Listings.ViewModels.Search.AuctionStatuses */
export var AuctionStatuses;
(function (AuctionStatuses) {
    AuctionStatuses[AuctionStatuses["None"] = 0] = "None";
    AuctionStatuses[AuctionStatuses["InProgress"] = 1] = "InProgress";
    AuctionStatuses[AuctionStatuses["Upcoming"] = 2] = "Upcoming";
    AuctionStatuses[AuctionStatuses["Completed"] = 4] = "Completed";
})(AuctionStatuses || (AuctionStatuses = {}));
/** CoStar.Api.Listings.ViewModels.Search.InvestmentTypes */
export var InvestmentTypes;
(function (InvestmentTypes) {
    InvestmentTypes[InvestmentTypes["None"] = 0] = "None";
    InvestmentTypes[InvestmentTypes["Core"] = 1] = "Core";
    InvestmentTypes[InvestmentTypes["ValueAdd"] = 2] = "ValueAdd";
    InvestmentTypes[InvestmentTypes["Opportunistic"] = 4] = "Opportunistic";
    InvestmentTypes[InvestmentTypes["TripleNet"] = 8] = "TripleNet";
    InvestmentTypes[InvestmentTypes["OpportunityZone"] = 16] = "OpportunityZone";
})(InvestmentTypes || (InvestmentTypes = {}));
/** CoStar.Api.Listings.ViewModels.Search.GeographyFilterType */
export var GeographyFilterType;
(function (GeographyFilterType) {
    GeographyFilterType[GeographyFilterType["Unknown"] = 0] = "Unknown";
    GeographyFilterType[GeographyFilterType["Property"] = 1] = "Property";
    GeographyFilterType[GeographyFilterType["PostalCode"] = 2] = "PostalCode";
    GeographyFilterType[GeographyFilterType["City"] = 3] = "City";
    GeographyFilterType[GeographyFilterType["Submarket"] = 5] = "Submarket";
    GeographyFilterType[GeographyFilterType["Street"] = 6] = "Street";
    GeographyFilterType[GeographyFilterType["ResearchMarket"] = 7] = "ResearchMarket";
    GeographyFilterType[GeographyFilterType["County"] = 10] = "County";
    GeographyFilterType[GeographyFilterType["Subdivision"] = 11] = "Subdivision";
    GeographyFilterType[GeographyFilterType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    GeographyFilterType[GeographyFilterType["Region"] = 17] = "Region";
    GeographyFilterType[GeographyFilterType["Cluster"] = 21] = "Cluster";
    GeographyFilterType[GeographyFilterType["Metro"] = 32] = "Metro";
    GeographyFilterType[GeographyFilterType["TrueCity"] = 133] = "TrueCity";
    GeographyFilterType[GeographyFilterType["CensusRegion"] = 134] = "CensusRegion";
})(GeographyFilterType || (GeographyFilterType = {}));
/** CoStar.Api.Listings.ViewModels.Search.Countries */
export var Countries;
(function (Countries) {
    Countries[Countries["None"] = 0] = "None";
    Countries[Countries["UnitedStates"] = 1] = "UnitedStates";
    Countries[Countries["Canada"] = 2] = "Canada";
    Countries[Countries["UnitedKingdom"] = 4] = "UnitedKingdom";
    Countries[Countries["Ireland"] = 8] = "Ireland";
    Countries[Countries["Germany"] = 16] = "Germany";
    Countries[Countries["Spain"] = 32] = "Spain";
    Countries[Countries["France"] = 64] = "France";
    Countries[Countries["Belgium"] = 256] = "Belgium";
    Countries[Countries["Switzerland"] = 512] = "Switzerland";
    Countries[Countries["Italy"] = 1024] = "Italy";
    Countries[Countries["Mexico"] = 2048] = "Mexico";
    Countries[Countries["Netherlands"] = 4096] = "Netherlands";
    Countries[Countries["Slovakia"] = 65536] = "Slovakia";
    Countries[Countries["Austria"] = 131072] = "Austria";
    Countries[Countries["CzechRepublic"] = 16777216] = "CzechRepublic";
    Countries[Countries["Denmark"] = 33554432] = "Denmark";
    Countries[Countries["Finland"] = 536870912] = "Finland";
    Countries[Countries["Hungary"] = 4294967296] = "Hungary";
    Countries[Countries["Norway"] = 17592186044416] = "Norway";
    Countries[Countries["Poland"] = 281474976710656] = "Poland";
    Countries[Countries["Portugal"] = 1125899906842624] = "Portugal";
    Countries[Countries["Sweden"] = 18014398509481984] = "Sweden";
})(Countries || (Countries = {}));
import { PropertySupertypes } from "../../../../../CoStar/Api/Brokers/ViewModels/Search/index.js";
/** CoStar.Api.Listings.ViewModels.Search.PropertySupertypes */
export { PropertySupertypes };
/** CoStar.Api.Listings.ViewModels.Search.FlexSubtypes */
export var FlexSubtypes;
(function (FlexSubtypes) {
    FlexSubtypes[FlexSubtypes["None"] = 0] = "None";
    FlexSubtypes[FlexSubtypes["LightManufacturing"] = 1] = "LightManufacturing";
    FlexSubtypes[FlexSubtypes["ResearchAndDevelopment"] = 2] = "ResearchAndDevelopment";
    FlexSubtypes[FlexSubtypes["Showroom"] = 4] = "Showroom";
    FlexSubtypes[FlexSubtypes["TelecomHotelDataHosting"] = 8] = "TelecomHotelDataHosting";
    FlexSubtypes[FlexSubtypes["LightDistribution"] = 16] = "LightDistribution";
    FlexSubtypes[FlexSubtypes["Bank"] = 32] = "Bank";
    FlexSubtypes[FlexSubtypes["BusinessPark"] = 64] = "BusinessPark";
    FlexSubtypes[FlexSubtypes["Cafe"] = 128] = "Cafe";
    FlexSubtypes[FlexSubtypes["FoodCourt"] = 256] = "FoodCourt";
    FlexSubtypes[FlexSubtypes["MixedRetail"] = 512] = "MixedRetail";
    FlexSubtypes[FlexSubtypes["OutletCenter"] = 1024] = "OutletCenter";
    FlexSubtypes[FlexSubtypes["PublicHouse"] = 2048] = "PublicHouse";
    FlexSubtypes[FlexSubtypes["RetailOutOfTown"] = 4096] = "RetailOutOfTown";
    FlexSubtypes[FlexSubtypes["SuperRegional"] = 8192] = "SuperRegional";
    FlexSubtypes[FlexSubtypes["TradeCounterPark"] = 16384] = "TradeCounterPark";
})(FlexSubtypes || (FlexSubtypes = {}));
/** CoStar.Api.Listings.ViewModels.Search.GeneralRetailSubtypes */
export var GeneralRetailSubtypes;
(function (GeneralRetailSubtypes) {
    GeneralRetailSubtypes[GeneralRetailSubtypes["None"] = 0] = "None";
    GeneralRetailSubtypes[GeneralRetailSubtypes["AutoDealership"] = 1] = "AutoDealership";
    GeneralRetailSubtypes[GeneralRetailSubtypes["AutoRepair"] = 2] = "AutoRepair";
    GeneralRetailSubtypes[GeneralRetailSubtypes["Bank"] = 4] = "Bank";
    GeneralRetailSubtypes[GeneralRetailSubtypes["Bar"] = 8] = "Bar";
    GeneralRetailSubtypes[GeneralRetailSubtypes["ConvenienceStore"] = 16] = "ConvenienceStore";
    GeneralRetailSubtypes[GeneralRetailSubtypes["DaycareCenter"] = 32] = "DaycareCenter";
    GeneralRetailSubtypes[GeneralRetailSubtypes["Drugstore"] = 64] = "Drugstore";
    GeneralRetailSubtypes[GeneralRetailSubtypes["FastFood"] = 128] = "FastFood";
    GeneralRetailSubtypes[GeneralRetailSubtypes["FuneralHome"] = 256] = "FuneralHome";
    GeneralRetailSubtypes[GeneralRetailSubtypes["Freestanding"] = 512] = "Freestanding";
    GeneralRetailSubtypes[GeneralRetailSubtypes["GardenCenter"] = 1024] = "GardenCenter";
    GeneralRetailSubtypes[GeneralRetailSubtypes["Restaurant"] = 2048] = "Restaurant";
    GeneralRetailSubtypes[GeneralRetailSubtypes["ServiceStation"] = 4096] = "ServiceStation";
    GeneralRetailSubtypes[GeneralRetailSubtypes["Storefront"] = 8192] = "Storefront";
    GeneralRetailSubtypes[GeneralRetailSubtypes["StorefrontRetailOffice"] = 16384] = "StorefrontRetailOffice";
    GeneralRetailSubtypes[GeneralRetailSubtypes["StorefrontRetailResidential"] = 32768] = "StorefrontRetailResidential";
    GeneralRetailSubtypes[GeneralRetailSubtypes["Supermarket"] = 65536] = "Supermarket";
    GeneralRetailSubtypes[GeneralRetailSubtypes["TruckStop"] = 131072] = "TruckStop";
    GeneralRetailSubtypes[GeneralRetailSubtypes["VeterinarianKennel"] = 262144] = "VeterinarianKennel";
    GeneralRetailSubtypes[GeneralRetailSubtypes["BowlingAlley"] = 524288] = "BowlingAlley";
    GeneralRetailSubtypes[GeneralRetailSubtypes["HealthClub"] = 1048576] = "HealthClub";
    GeneralRetailSubtypes[GeneralRetailSubtypes["MovieTheatre"] = 2097152] = "MovieTheatre";
    GeneralRetailSubtypes[GeneralRetailSubtypes["DepartmentStore"] = 4194304] = "DepartmentStore";
    GeneralRetailSubtypes[GeneralRetailSubtypes["RetailBuilding"] = 8388608] = "RetailBuilding";
    GeneralRetailSubtypes[GeneralRetailSubtypes["QuickService"] = 16777216] = "QuickService";
})(GeneralRetailSubtypes || (GeneralRetailSubtypes = {}));
/** CoStar.Api.Listings.ViewModels.Search.HealthcareSubtypes */
export var HealthcareSubtypes;
(function (HealthcareSubtypes) {
    HealthcareSubtypes[HealthcareSubtypes["None"] = 0] = "None";
    HealthcareSubtypes[HealthcareSubtypes["AssistedLiving"] = 1] = "AssistedLiving";
    HealthcareSubtypes[HealthcareSubtypes["CongregateSeniorHousing"] = 2] = "CongregateSeniorHousing";
    HealthcareSubtypes[HealthcareSubtypes["ContinuingCareRetirementCommunity"] = 4] = "ContinuingCareRetirementCommunity";
    HealthcareSubtypes[HealthcareSubtypes["Hospital"] = 8] = "Hospital";
    HealthcareSubtypes[HealthcareSubtypes["RehabilitationCenter"] = 16] = "RehabilitationCenter";
    HealthcareSubtypes[HealthcareSubtypes["SkilledNursingFacility"] = 32] = "SkilledNursingFacility";
    HealthcareSubtypes[HealthcareSubtypes["IndependentLiving"] = 64] = "IndependentLiving";
})(HealthcareSubtypes || (HealthcareSubtypes = {}));
/** CoStar.Api.Listings.ViewModels.Search.HospitalitySubtypes */
export var HospitalitySubtypes;
(function (HospitalitySubtypes) {
    HospitalitySubtypes[HospitalitySubtypes["None"] = 0] = "None";
    HospitalitySubtypes[HospitalitySubtypes["Hotel"] = 1] = "Hotel";
    HospitalitySubtypes[HospitalitySubtypes["HotelCasino"] = 2] = "HotelCasino";
    HospitalitySubtypes[HospitalitySubtypes["Motel"] = 4] = "Motel";
    HospitalitySubtypes[HospitalitySubtypes["SingleRoomOccupancyHotel"] = 8] = "SingleRoomOccupancyHotel";
    HospitalitySubtypes[HospitalitySubtypes["ServicedApartment"] = 16] = "ServicedApartment";
    HospitalitySubtypes[HospitalitySubtypes["Hostel"] = 32] = "Hostel";
    HospitalitySubtypes[HospitalitySubtypes["BedAndBreakfast"] = 64] = "BedAndBreakfast";
})(HospitalitySubtypes || (HospitalitySubtypes = {}));
/** CoStar.Api.Listings.ViewModels.Search.IndustrialSubtypes */
export var IndustrialSubtypes;
(function (IndustrialSubtypes) {
    IndustrialSubtypes[IndustrialSubtypes["None"] = 0] = "None";
    IndustrialSubtypes[IndustrialSubtypes["TelecomHotelDataHosting"] = 1] = "TelecomHotelDataHosting";
    IndustrialSubtypes[IndustrialSubtypes["Distribution"] = 2] = "Distribution";
    IndustrialSubtypes[IndustrialSubtypes["FoodProcessing"] = 4] = "FoodProcessing";
    IndustrialSubtypes[IndustrialSubtypes["Manufacturing"] = 8] = "Manufacturing";
    IndustrialSubtypes[IndustrialSubtypes["RefrigerationColdStorage"] = 16] = "RefrigerationColdStorage";
    IndustrialSubtypes[IndustrialSubtypes["Showroom"] = 32] = "Showroom";
    IndustrialSubtypes[IndustrialSubtypes["TruckTerminal"] = 64] = "TruckTerminal";
    IndustrialSubtypes[IndustrialSubtypes["Warehouse"] = 128] = "Warehouse";
    IndustrialSubtypes[IndustrialSubtypes["Service"] = 256] = "Service";
    IndustrialSubtypes[IndustrialSubtypes["LightIndustrial"] = 512] = "LightIndustrial";
})(IndustrialSubtypes || (IndustrialSubtypes = {}));
/** CoStar.Api.Listings.ViewModels.Search.OfficeSubtypes */
export var OfficeSubtypes;
(function (OfficeSubtypes) {
    OfficeSubtypes[OfficeSubtypes["None"] = 0] = "None";
    OfficeSubtypes[OfficeSubtypes["LoftCreativeSpace"] = 1] = "LoftCreativeSpace";
    OfficeSubtypes[OfficeSubtypes["Medical"] = 2] = "Medical";
    OfficeSubtypes[OfficeSubtypes["TelecomHotelDataHosting"] = 4] = "TelecomHotelDataHosting";
    OfficeSubtypes[OfficeSubtypes["OfficeResidential"] = 8] = "OfficeResidential";
    OfficeSubtypes[OfficeSubtypes["OfficeLiveWorkUnit"] = 16] = "OfficeLiveWorkUnit";
    OfficeSubtypes[OfficeSubtypes["IndustrialLiveWorkUnit"] = 32] = "IndustrialLiveWorkUnit";
    OfficeSubtypes[OfficeSubtypes["BusinessPark"] = 64] = "BusinessPark";
    OfficeSubtypes[OfficeSubtypes["CallCenter"] = 128] = "CallCenter";
    OfficeSubtypes[OfficeSubtypes["D1"] = 256] = "D1";
    OfficeSubtypes[OfficeSubtypes["D2"] = 512] = "D2";
    OfficeSubtypes[OfficeSubtypes["ServicedOffices"] = 1024] = "ServicedOffices";
})(OfficeSubtypes || (OfficeSubtypes = {}));
/** CoStar.Api.Listings.ViewModels.Search.SpecialtySubtypes */
export var SpecialtySubtypes;
(function (SpecialtySubtypes) {
    SpecialtySubtypes[SpecialtySubtypes["None"] = 0] = "None";
    SpecialtySubtypes[SpecialtySubtypes["Carwash"] = 1] = "Carwash";
    SpecialtySubtypes[SpecialtySubtypes["ParkingGarage"] = 2] = "ParkingGarage";
    SpecialtySubtypes[SpecialtySubtypes["ParkingLot"] = 4] = "ParkingLot";
    SpecialtySubtypes[SpecialtySubtypes["Airport"] = 8] = "Airport";
    SpecialtySubtypes[SpecialtySubtypes["AirplaneHangar"] = 16] = "AirplaneHangar";
    SpecialtySubtypes[SpecialtySubtypes["AutoSalvageFacility"] = 32] = "AutoSalvageFacility";
    SpecialtySubtypes[SpecialtySubtypes["CementGravelPlant"] = 64] = "CementGravelPlant";
    SpecialtySubtypes[SpecialtySubtypes["ChemicalOilRefinery"] = 128] = "ChemicalOilRefinery";
    SpecialtySubtypes[SpecialtySubtypes["Landfill"] = 256] = "Landfill";
    SpecialtySubtypes[SpecialtySubtypes["RailroadYard"] = 512] = "RailroadYard";
    SpecialtySubtypes[SpecialtySubtypes["SelfStorage"] = 1024] = "SelfStorage";
    SpecialtySubtypes[SpecialtySubtypes["Shipyard"] = 2048] = "Shipyard";
    SpecialtySubtypes[SpecialtySubtypes["UtilitySubstation"] = 4096] = "UtilitySubstation";
    SpecialtySubtypes[SpecialtySubtypes["WaterTreatmentFacility"] = 8192] = "WaterTreatmentFacility";
    SpecialtySubtypes[SpecialtySubtypes["CemeteryMausoleum"] = 16384] = "CemeteryMausoleum";
    SpecialtySubtypes[SpecialtySubtypes["CorrectionalFacility"] = 32768] = "CorrectionalFacility";
    SpecialtySubtypes[SpecialtySubtypes["LodgeMeetingHall"] = 65536] = "LodgeMeetingHall";
    SpecialtySubtypes[SpecialtySubtypes["Marina"] = 131072] = "Marina";
    SpecialtySubtypes[SpecialtySubtypes["MovieRadioTVStudio"] = 262144] = "MovieRadioTVStudio";
    SpecialtySubtypes[SpecialtySubtypes["PoliceFireStation"] = 524288] = "PoliceFireStation";
    SpecialtySubtypes[SpecialtySubtypes["PostOffice"] = 1048576] = "PostOffice";
    SpecialtySubtypes[SpecialtySubtypes["PublicLibrary"] = 2097152] = "PublicLibrary";
    SpecialtySubtypes[SpecialtySubtypes["RadioTVTransmissionFacilities"] = 4194304] = "RadioTVTransmissionFacilities";
    SpecialtySubtypes[SpecialtySubtypes["ReligiousFacility"] = 8388608] = "ReligiousFacility";
    SpecialtySubtypes[SpecialtySubtypes["Schools"] = 16777216] = "Schools";
    SpecialtySubtypes[SpecialtySubtypes["TrailerCamperPark"] = 33554432] = "TrailerCamperPark";
    SpecialtySubtypes[SpecialtySubtypes["WineryVineyard"] = 67108864] = "WineryVineyard";
    SpecialtySubtypes[SpecialtySubtypes["WaterRetentionFacility"] = 134217728] = "WaterRetentionFacility";
    SpecialtySubtypes[SpecialtySubtypes["SororityFraternityHouse"] = 268435456] = "SororityFraternityHouse";
    SpecialtySubtypes[SpecialtySubtypes["Shelter"] = 536870912] = "Shelter";
    SpecialtySubtypes[SpecialtySubtypes["RecyclingCenter"] = 1073741824] = "RecyclingCenter";
    SpecialtySubtypes[SpecialtySubtypes["Lumberyard"] = 2147483648] = "Lumberyard";
    SpecialtySubtypes[SpecialtySubtypes["DriveInMovie"] = 4294967296] = "DriveInMovie";
    SpecialtySubtypes[SpecialtySubtypes["ContractorStorageYard"] = 8589934592] = "ContractorStorageYard";
    SpecialtySubtypes[SpecialtySubtypes["Conference"] = 17179869184] = "Conference";
    SpecialtySubtypes[SpecialtySubtypes["OfficeAndIndustrial"] = 34359738368] = "OfficeAndIndustrial";
    SpecialtySubtypes[SpecialtySubtypes["ResidentialIncome"] = 68719476736] = "ResidentialIncome";
})(SpecialtySubtypes || (SpecialtySubtypes = {}));
/** CoStar.Api.Listings.ViewModels.Search.MultifamilySubtypes */
export var MultifamilySubtypes;
(function (MultifamilySubtypes) {
    MultifamilySubtypes[MultifamilySubtypes["None"] = 0] = "None";
    MultifamilySubtypes[MultifamilySubtypes["Apartments"] = 1] = "Apartments";
    MultifamilySubtypes[MultifamilySubtypes["ManufacturedHousingMobileHomePark"] = 2] = "ManufacturedHousingMobileHomePark";
    MultifamilySubtypes[MultifamilySubtypes["Dormitory"] = 4] = "Dormitory";
})(MultifamilySubtypes || (MultifamilySubtypes = {}));
/** CoStar.Api.Listings.ViewModels.Search.SportsAndEntertainmentSubtypes */
export var SportsAndEntertainmentSubtypes;
(function (SportsAndEntertainmentSubtypes) {
    SportsAndEntertainmentSubtypes[SportsAndEntertainmentSubtypes["None"] = 0] = "None";
    SportsAndEntertainmentSubtypes[SportsAndEntertainmentSubtypes["AmusementPark"] = 1] = "AmusementPark";
    SportsAndEntertainmentSubtypes[SportsAndEntertainmentSubtypes["BaseballField"] = 2] = "BaseballField";
    SportsAndEntertainmentSubtypes[SportsAndEntertainmentSubtypes["Casino"] = 4] = "Casino";
    SportsAndEntertainmentSubtypes[SportsAndEntertainmentSubtypes["GolfCourseDrivingRange"] = 8] = "GolfCourseDrivingRange";
    SportsAndEntertainmentSubtypes[SportsAndEntertainmentSubtypes["HorseStables"] = 16] = "HorseStables";
    SportsAndEntertainmentSubtypes[SportsAndEntertainmentSubtypes["Racetrack"] = 32] = "Racetrack";
    SportsAndEntertainmentSubtypes[SportsAndEntertainmentSubtypes["SkatingRink"] = 64] = "SkatingRink";
    SportsAndEntertainmentSubtypes[SportsAndEntertainmentSubtypes["SwimmingPool"] = 128] = "SwimmingPool";
    SportsAndEntertainmentSubtypes[SportsAndEntertainmentSubtypes["TheaterConcertHall"] = 256] = "TheaterConcertHall";
    SportsAndEntertainmentSubtypes[SportsAndEntertainmentSubtypes["AllLeisure"] = 512] = "AllLeisure";
    SportsAndEntertainmentSubtypes[SportsAndEntertainmentSubtypes["FitnessCenter"] = 1024] = "FitnessCenter";
    SportsAndEntertainmentSubtypes[SportsAndEntertainmentSubtypes["Nightclub"] = 2048] = "Nightclub";
})(SportsAndEntertainmentSubtypes || (SportsAndEntertainmentSubtypes = {}));
/** CoStar.Api.Listings.ViewModels.Search.LandTypes */
export var LandTypes;
(function (LandTypes) {
    LandTypes[LandTypes["None"] = 0] = "None";
    LandTypes[LandTypes["Residential"] = 1] = "Residential";
    LandTypes[LandTypes["Commercial"] = 2] = "Commercial";
    LandTypes[LandTypes["Industrial"] = 4] = "Industrial";
    LandTypes[LandTypes["Agricultural"] = 8] = "Agricultural";
})(LandTypes || (LandTypes = {}));
/** CoStar.Api.Listings.ViewModels.Search.ApartmentStyleTypes */
export var ApartmentStyleTypes;
(function (ApartmentStyleTypes) {
    ApartmentStyleTypes[ApartmentStyleTypes["None"] = 0] = "None";
    ApartmentStyleTypes[ApartmentStyleTypes["Garden"] = 1] = "Garden";
    ApartmentStyleTypes[ApartmentStyleTypes["MidRise"] = 2] = "MidRise";
    ApartmentStyleTypes[ApartmentStyleTypes["HighRise"] = 4] = "HighRise";
    ApartmentStyleTypes[ApartmentStyleTypes["LowRise"] = 8] = "LowRise";
    ApartmentStyleTypes[ApartmentStyleTypes["SingleFamilyHome"] = 16] = "SingleFamilyHome";
    ApartmentStyleTypes[ApartmentStyleTypes["Townhome"] = 32] = "Townhome";
})(ApartmentStyleTypes || (ApartmentStyleTypes = {}));
/** CoStar.Api.Listings.ViewModels.Search.ShoppingCenterTypes */
export var ShoppingCenterTypes;
(function (ShoppingCenterTypes) {
    ShoppingCenterTypes[ShoppingCenterTypes["None"] = 0] = "None";
    ShoppingCenterTypes[ShoppingCenterTypes["AirportRetail"] = 1] = "AirportRetail";
    ShoppingCenterTypes[ShoppingCenterTypes["CommunityCenter"] = 2] = "CommunityCenter";
    ShoppingCenterTypes[ShoppingCenterTypes["LifestyleCenter"] = 4] = "LifestyleCenter";
    ShoppingCenterTypes[ShoppingCenterTypes["NeighborhoodCenter"] = 8] = "NeighborhoodCenter";
    ShoppingCenterTypes[ShoppingCenterTypes["OutletCenter"] = 16] = "OutletCenter";
    ShoppingCenterTypes[ShoppingCenterTypes["PowerCenter"] = 32] = "PowerCenter";
    ShoppingCenterTypes[ShoppingCenterTypes["RegionalMall"] = 64] = "RegionalMall";
    ShoppingCenterTypes[ShoppingCenterTypes["ThemeFestivalCenter"] = 128] = "ThemeFestivalCenter";
    ShoppingCenterTypes[ShoppingCenterTypes["StripCenter"] = 256] = "StripCenter";
    ShoppingCenterTypes[ShoppingCenterTypes["SuperRegionalMall"] = 512] = "SuperRegionalMall";
    ShoppingCenterTypes[ShoppingCenterTypes["RegionalPrime"] = 1024] = "RegionalPrime";
    ShoppingCenterTypes[ShoppingCenterTypes["MajorUrbanCentre"] = 2048] = "MajorUrbanCentre";
    ShoppingCenterTypes[ShoppingCenterTypes["UrbanCentre"] = 4096] = "UrbanCentre";
    ShoppingCenterTypes[ShoppingCenterTypes["District"] = 8192] = "District";
    ShoppingCenterTypes[ShoppingCenterTypes["SolusUnit"] = 16384] = "SolusUnit";
    ShoppingCenterTypes[ShoppingCenterTypes["ShoppingPark"] = 32768] = "ShoppingPark";
    ShoppingCenterTypes[ShoppingCenterTypes["RetailPark"] = 65536] = "RetailPark";
    ShoppingCenterTypes[ShoppingCenterTypes["LeisurePark"] = 131072] = "LeisurePark";
})(ShoppingCenterTypes || (ShoppingCenterTypes = {}));
/** CoStar.Api.Listings.ViewModels.Search.SpaceUses */
export var SpaceUses;
(function (SpaceUses) {
    SpaceUses[SpaceUses["None"] = 0] = "None";
    SpaceUses[SpaceUses["Office"] = 1] = "Office";
    SpaceUses[SpaceUses["Medical"] = 2] = "Medical";
    SpaceUses[SpaceUses["Retail"] = 4] = "Retail";
    SpaceUses[SpaceUses["Flex"] = 8] = "Flex";
    SpaceUses[SpaceUses["Industrial"] = 16] = "Industrial";
})(SpaceUses || (SpaceUses = {}));
/** CoStar.Api.Listings.ViewModels.Search.SpaceUsePropertyTypeInteraction */
export var SpaceUsePropertyTypeInteraction;
(function (SpaceUsePropertyTypeInteraction) {
    SpaceUsePropertyTypeInteraction[SpaceUsePropertyTypeInteraction["Intersect"] = 0] = "Intersect";
    SpaceUsePropertyTypeInteraction[SpaceUsePropertyTypeInteraction["Union"] = 1] = "Union";
})(SpaceUsePropertyTypeInteraction || (SpaceUsePropertyTypeInteraction = {}));
/** CoStar.Api.Listings.ViewModels.Search.PropertyGroups */
export var PropertyGroups;
(function (PropertyGroups) {
    PropertyGroups[PropertyGroups["None"] = 0] = "None";
    PropertyGroups[PropertyGroups["ShoppingCenter"] = 1] = "ShoppingCenter";
    PropertyGroups[PropertyGroups["BusinessPark"] = 2] = "BusinessPark";
})(PropertyGroups || (PropertyGroups = {}));
/** CoStar.Api.Listings.ViewModels.Search.ListingAmenities */
export var ListingAmenities;
(function (ListingAmenities) {
    ListingAmenities[ListingAmenities["None"] = 0] = "None";
    ListingAmenities[ListingAmenities["AirConditioning_Rooms"] = 1] = "AirConditioning_Rooms";
    ListingAmenities[ListingAmenities["AirConditioning_Space"] = 2] = "AirConditioning_Space";
    ListingAmenities[ListingAmenities["AirConditioning_Building"] = 4] = "AirConditioning_Building";
    ListingAmenities[ListingAmenities["GuestParking"] = 8] = "GuestParking";
    ListingAmenities[ListingAmenities["NaturalLight"] = 16] = "NaturalLight";
    ListingAmenities[ListingAmenities["RaisedFloor"] = 32] = "RaisedFloor";
    ListingAmenities[ListingAmenities["BicycleStorage"] = 64] = "BicycleStorage";
    ListingAmenities[ListingAmenities["SecuritySystem_Building"] = 128] = "SecuritySystem_Building";
    ListingAmenities[ListingAmenities["BioTechLabSpace"] = 256] = "BioTechLabSpace";
    ListingAmenities[ListingAmenities["Dock"] = 512] = "Dock";
    ListingAmenities[ListingAmenities["SecuritySystem_Space"] = 1024] = "SecuritySystem_Space";
    ListingAmenities[ListingAmenities["CarChargingStation"] = 2048] = "CarChargingStation";
    ListingAmenities[ListingAmenities["StreetParkingOnly"] = 4096] = "StreetParkingOnly";
    ListingAmenities[ListingAmenities["SuspendedCeilings"] = 8192] = "SuspendedCeilings";
    ListingAmenities[ListingAmenities["PremiumViews"] = 16384] = "PremiumViews";
    ListingAmenities[ListingAmenities["CommuterRail"] = 32768] = "CommuterRail";
    ListingAmenities[ListingAmenities["Concierge"] = 65536] = "Concierge";
    ListingAmenities[ListingAmenities["FireAlarm"] = 131072] = "FireAlarm";
    ListingAmenities[ListingAmenities["Toilets_Space"] = 262144] = "Toilets_Space";
    ListingAmenities[ListingAmenities["DayCare"] = 524288] = "DayCare";
    ListingAmenities[ListingAmenities["Doorman"] = 1048576] = "Doorman";
    ListingAmenities[ListingAmenities["DryCleaner"] = 2097152] = "DryCleaner";
    ListingAmenities[ListingAmenities["DryCleanerService"] = 4194304] = "DryCleanerService";
    ListingAmenities[ListingAmenities["Toilets_Building"] = 8388608] = "Toilets_Building";
    ListingAmenities[ListingAmenities["TwentyFourHourAccess"] = 16777216] = "TwentyFourHourAccess";
    ListingAmenities[ListingAmenities["Balcony"] = 33554432] = "Balcony";
    ListingAmenities[ListingAmenities["FitnessCenter"] = 67108864] = "FitnessCenter";
    ListingAmenities[ListingAmenities["Utilities"] = 134217728] = "Utilities";
    ListingAmenities[ListingAmenities["CCTV"] = 268435456] = "CCTV";
    ListingAmenities[ListingAmenities["Furnished"] = 536870912] = "Furnished";
    ListingAmenities[ListingAmenities["ConferenceRooms"] = 1073741824] = "ConferenceRooms";
    ListingAmenities[ListingAmenities["ConferencingFacility"] = 2147483648] = "ConferencingFacility";
    ListingAmenities[ListingAmenities["ControlledAccess"] = 4294967296] = "ControlledAccess";
    ListingAmenities[ListingAmenities["DDACompliant"] = 8589934592] = "DDACompliant";
    ListingAmenities[ListingAmenities["DisabledFacilities"] = 17179869184] = "DisabledFacilities";
    ListingAmenities[ListingAmenities["Kitchen"] = 34359738368] = "Kitchen";
    ListingAmenities[ListingAmenities["DisplayWindow"] = 68719476736] = "DisplayWindow";
    ListingAmenities[ListingAmenities["SmokeDetector_Space"] = 137438953472] = "SmokeDetector_Space";
    ListingAmenities[ListingAmenities["EnergyPerformanceRatingA"] = 274877906944] = "EnergyPerformanceRatingA";
    ListingAmenities[ListingAmenities["EnergyPerformanceRatingB"] = 549755813888] = "EnergyPerformanceRatingB";
    ListingAmenities[ListingAmenities["EnergyPerformanceRatingC"] = 1099511627776] = "EnergyPerformanceRatingC";
    ListingAmenities[ListingAmenities["EnergyPerformanceRatingD"] = 2199023255552] = "EnergyPerformanceRatingD";
    ListingAmenities[ListingAmenities["MetroSubway"] = 4398046511104] = "MetroSubway";
    ListingAmenities[ListingAmenities["EnergyPerformanceRatingE"] = 8796093022208] = "EnergyPerformanceRatingE";
    ListingAmenities[ListingAmenities["EnergyStarLabeled"] = 17592186044416] = "EnergyStarLabeled";
    ListingAmenities[ListingAmenities["Pool"] = 35184372088832] = "Pool";
    ListingAmenities[ListingAmenities["HearingImpairedAccessible"] = 70368744177664] = "HearingImpairedAccessible";
    ListingAmenities[ListingAmenities["KeyFobEntry"] = 140737488355328] = "KeyFobEntry";
    ListingAmenities[ListingAmenities["Reception"] = 281474976710656] = "Reception";
    ListingAmenities[ListingAmenities["Restaurant"] = 562949953421312] = "Restaurant";
    ListingAmenities[ListingAmenities["LEEDCertified"] = 1125899906842624] = "LEEDCertified";
    ListingAmenities[ListingAmenities["LEEDCertifiedGold"] = 2251799813685248] = "LEEDCertifiedGold";
    ListingAmenities[ListingAmenities["LEEDCertifiedPlatinum"] = 4503599627370496] = "LEEDCertifiedPlatinum";
    ListingAmenities[ListingAmenities["LEEDCertifiedSilver"] = 9007199254740992] = "LEEDCertifiedSilver";
    ListingAmenities[ListingAmenities["RoofTerrace"] = 18014398509481984] = "RoofTerrace";
    ListingAmenities[ListingAmenities["Waterfront"] = 36028797018963970] = "Waterfront";
    ListingAmenities[ListingAmenities["WheelchairAccessible_Building"] = 72057594037927940] = "WheelchairAccessible_Building";
    ListingAmenities[ListingAmenities["WheelchairAccessible_Space"] = 144115188075855870] = "WheelchairAccessible_Space";
    ListingAmenities[ListingAmenities["SmokeDetector_Building"] = 288230376151711740] = "SmokeDetector_Building";
})(ListingAmenities || (ListingAmenities = {}));
/** CoStar.Api.Listings.ViewModels.Search.SortType */
export var SortType;
(function (SortType) {
    SortType[SortType["Default"] = 0] = "Default";
    SortType[SortType["Newest"] = 1] = "Newest";
    SortType[SortType["Oldest"] = 2] = "Oldest";
    SortType[SortType["PriceLowest"] = 3] = "PriceLowest";
    SortType[SortType["PriceHighest"] = 4] = "PriceHighest";
    SortType[SortType["RentLowest"] = 5] = "RentLowest";
    SortType[SortType["RentHighest"] = 6] = "RentHighest";
    SortType[SortType["CapRateLowest"] = 7] = "CapRateLowest";
    SortType[SortType["CapRateHighest"] = 8] = "CapRateHighest";
    SortType[SortType["BuildingAreaLowest"] = 9] = "BuildingAreaLowest";
    SortType[SortType["BuildingAreaHighest"] = 10] = "BuildingAreaHighest";
    SortType[SortType["AvailableSpaceLowest"] = 11] = "AvailableSpaceLowest";
    SortType[SortType["AvailableSpaceHighest"] = 12] = "AvailableSpaceHighest";
    SortType[SortType["CityAscending"] = 13] = "CityAscending";
    SortType[SortType["CityDescending"] = 14] = "CityDescending";
    SortType[SortType["HasVideo"] = 15] = "HasVideo";
    SortType[SortType["RecentlyUpdated"] = 16] = "RecentlyUpdated";
    SortType[SortType["Has3DTour"] = 17] = "Has3DTour";
    SortType[SortType["RatingLowest"] = 21] = "RatingLowest";
    SortType[SortType["RatingHighest"] = 22] = "RatingHighest";
})(SortType || (SortType = {}));
